import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { guiaColumnasFijas } from "../../../guias/index";
import { SelectedGuia } from "./types";

type Entity = SelectedGuia;
export interface Deps {
    onSeleccionar: (x: Entity, value: boolean) => void;
    onVer: (x: Entity) => void;
}
export function columnas(deps: Deps) {
    const ret: kea.Grid2Column<Entity>[] = [
        { title: "", key: "seleccionar", cell: x => ({ data: x.Selected, view: () => <kea.Checkbox value={x.Selected} onChange={sel => deps.onSeleccionar(x, sel)} /> }) },
        kea.columnaBotones([
            {
                iconClass: fa("eye"),
                onClick: deps.onVer,
                tooltip: "Ver detalle"
            }
        ]),
        ...guiaColumnasFijas
    ];

    const rowStyleCol = kea.applyRowStyleToColumns(ret, (item: Entity) =>
        item.Rechazado ? { background: "#F7F7D4" } : {});
    return rowStyleCol;
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/ocurre/componentes/multiguias/columns.tsx